import React, { useState } from 'react'
import Add from './Add'
import CallDashboard from './callDashboard'
export default function Main({admin}) {
 const [callTab,setcallTab] =useState("list")

     const handlecallTab = (type) => {
        setcallTab(type)
    }
    return (
        <>
            <div style={{ display: "flex", textAlign: "center", marginTop: "30px", marginLeft: "20px", gap: '15px' }}>
                <div className={`expenseListTab ${callTab == "list" ? "active" : ""}`} onClick={() => handlecallTab("list")}>
                    <i className='fa fa-list'></i>
                </div>
                <div className={`expenseListTab ${callTab == "add" ? "active" : ""}`} onClick={() => handlecallTab("add")}>
                    <i className='fa fa-plus'></i>
                </div>
            </div>

            {
                callTab == "list" ? 
                <CallDashboard admin={admin}/> 
                :
                ""
            }
            {
                callTab == "add" ? 
                <Add /> 
                :
                ""
            }
        </>
    )
}
